<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-form-group :label="$t('name')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('city_code')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.city_code) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('state')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.state_id) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    //Service
    import CityService from "@/services/CityService";

    export default {
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                form: {
                    state_id: null,
                    city_code: null,
                    name: null,
                }
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                CityService.get(id)
                                      .then((response) => {
                                          this.form = response.data.data;
                                      })
                                      .catch((error) => {
                                          this.showErrors(error)
                                      })
            }
        }
    }
</script>
